(() => {
  const LINK_ID = 'nlh-guaranteed-quote-link';
  const STYLE_ID = 'nlh-guaranteed-quote-link-style';
  const QUOTE_PATH = '/pages/product-quote-center';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #${LINK_ID} {
        display: none;
        align-items: center;
        align-self: stretch;
        flex: 0 0 auto;
        color: var(--color-foreground);
        font-family: var(--font-body--family);
        font-size: 0.875rem;
        line-height: 1;
        text-decoration: none;
        white-space: nowrap;
      }

      @media screen and (min-width: 750px) {
        #header-component[data-menu-style='menu'] #${LINK_ID} {
          display: flex;
        }
      }

      #header-component header-menu .menu-list__list-item:has(> a[href*='${QUOTE_PATH}']) {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  function ensureQuoteLink() {
    ensureStyle();

    const headerMenu = document.querySelector('#header-component header-menu');
    if (!headerMenu) return;

    let quoteLink = document.getElementById(LINK_ID);
    if (!quoteLink) {
      quoteLink = document.createElement('a');
      quoteLink.id = LINK_ID;
      quoteLink.dataset.nlhGuaranteedQuoteLink = 'true';
      quoteLink.href = QUOTE_PATH;
      quoteLink.textContent = '产品报价中心';
    }

    if (quoteLink.previousElementSibling !== headerMenu) {
      headerMenu.insertAdjacentElement('afterend', quoteLink);
    }

    if (window.location.pathname === QUOTE_PATH) {
      quoteLink.setAttribute('aria-current', 'page');
    } else {
      quoteLink.removeAttribute('aria-current');
    }
  }

  let frame = 0;
  const scheduleEnsure = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      ensureQuoteLink();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureQuoteLink, { once: true });
  } else {
    ensureQuoteLink();
  }

  new MutationObserver(scheduleEnsure).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  document.addEventListener('shopify:section:load', ensureQuoteLink);
})();
